import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LocaleProvider } from "./context/LocaleContext";
import Home from "./pages/Home";
import About from "./pages/About";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";

const AppRoutes = () => {
  return (
    <Router>
      <LocaleProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
        </Routes>
      </LocaleProvider>
    </Router>
  );
};

export default AppRoutes;
